<template>
  <Card class="related-order-card elevated">
    <template #content>
      <div class="flex flex-column flex-gap-1">
        <Skeleton width="25%" height="1rem" class="bg-gray-dark" />
        <Skeleton width="50%" height="1rem" class="bg-gray" />
      </div>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';
</script>
